export const useLoadUserOverallInfoInternetAware = () => undefined;
